(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lma-shop-by-brand"] && !Shopify.designMode) return;
  try {
    
(() => {
  const observers = new WeakMap();
  const initialize = parent => {
    parent.querySelectorAll('[data-lma-brand-marquee]').forEach(marquee => {
      if (observers.has(marquee)) return;
      const track = marquee.querySelector('.scrolling-logos__track');
      const markDuplicates = () => {
        const brands = new Set();
        Array.from(track.children).forEach(item => {
          const link = item.querySelector('.lma-brands__card');
          if (!link) return;
          const brand = link.getAttribute('href');
          if (brands.has(brand)) {
            item.dataset.lmaBrandDuplicate = 'true';
            item.setAttribute('aria-hidden', 'true');
            link.setAttribute('tabindex', '-1');
          } else brands.add(brand);
        });
      };
      markDuplicates();
      const observer = new MutationObserver(markDuplicates);
      observer.observe(track, { childList: true });
      observers.set(marquee, observer);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-lma-brand-marquee]').forEach(marquee => {
      observers.get(marquee)?.disconnect();
      observers.delete(marquee);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
